(() => {
  if (window.gerhauAirLabelsReady) return;
  window.gerhauAirLabelsReady = true;
  const ru = document.documentElement.lang.toLowerCase().startsWith('ru');
  const copy = ru
    ? { rating: 'Оценка', close: 'Закрыть', files: 'Добавить файлы', review: 'Ваш отзыв' }
    : { rating: 'Баға', close: 'Жабу', files: 'Файлдарды қосу', review: 'Пікіріңіз' };
  const roots = '#kz-product-reviews, #AirReviews-Modal';
  const lists = new WeakMap();
  const localizeSamples = root => {
    const notice = root.querySelector('.AirReviews-Sample__Header');
    if (!notice || root.dataset.editorPreview !== 'true') return;
    const source = root.querySelector('.kz-reviews-preview-copy');
    if (!source) return;
    let preview;
    try { preview = JSON.parse(source.textContent); } catch { return; }
    root.classList.add('kz-reviews--sample-preview');
    if (notice.textContent !== preview.notice) notice.textContent = preview.notice;
    root.querySelectorAll('.AirReviews-Blocks__ReviewDetails').forEach((card, index) => {
      const body = card.querySelector('.Avada-ReviewContent__LimitLength');
      const author = card.querySelector('.AirReviews-Blocks__AuthorName');
      const number = body?.className.match(/Avada-ReviewContent-review-(\d+)/)?.[1];
      if (number === undefined) return;
      const text = preview.samples[Number(number) % preview.samples.length];
      if (body.textContent !== text) body.textContent = text;
      const name = `${preview.author} ${Number(number) + 1}`;
      if (author && author.textContent !== name) author.textContent = name;
    });
  };
  const paginate = () => {
    const root = document.querySelector('#kz-product-reviews');
    if (!root) return;
    localizeSamples(root);
    root.querySelectorAll('.AirReviews-Select').forEach(select => {
      const value = select.querySelector('.AirReviews-Select__Value')?.textContent.trim() || '';
      if (!/^\d+$/.test(value)) return;
      select.classList.add('kz-reviews-native-size');
    });
    root.querySelectorAll('.AirReviews-Blocks__ListReview').forEach(list => {
      const cards = Array.from(list.children).filter(card => card.classList.contains('AirReviews-Blocks__ReviewDetails'));
      let state = lists.get(list);
      if (!state) {
        const nav = document.createElement('nav');
        nav.className = 'kz-reviews-pages';
        nav.setAttribute('aria-label', root.dataset.reviewsPages);
        const previous = document.createElement('button');
        const next = document.createElement('button');
        const count = document.createElement('span');
        previous.type = next.type = 'button';
        previous.textContent = root.dataset.reviewsPrevious;
        next.textContent = root.dataset.reviewsNext;
        count.setAttribute('aria-live', 'polite');
        nav.append(previous, count, next);
        state = { start: 0, nav, previous, next, count, first: cards[0], signature: '' };
        lists.set(list, state);
        previous.addEventListener('click', () => { state.start = Math.max(0, state.start - 5); paginate(); });
        next.addEventListener('click', () => { state.start += 5; paginate(); });
        list.after(nav);
      }
      const signature = cards[0]?.querySelector('.AirReviews-Blocks__Content')?.textContent || '';
      if (state.first !== cards[0] || state.signature !== signature) {
        state.first = cards[0];
        state.signature = signature;
        state.start = 0;
      }
      state.start = Math.min(state.start, Math.max(0, Math.ceil(cards.length / 5) - 1) * 5);
      cards.forEach((card, index) => {
        const hidden = index < state.start || index >= state.start + 5;
        if (card.classList.contains('kz-review-page-hidden') !== hidden) card.classList.toggle('kz-review-page-hidden', hidden);
      });
      list.dataset.kzPaginationReady = 'true';
      state.previous.disabled = state.start === 0;
      state.next.disabled = state.start + 5 >= cards.length;
      const range = `${state.start + 1}–${Math.min(state.start + 5, cards.length)} / ${cards.length}`;
      if (state.count.textContent !== range) state.count.textContent = range;
      state.nav.hidden = cards.length <= 5;
    });
  };
  const label = (element, value) => {
    if (element.getAttribute('aria-label') !== value) element.setAttribute('aria-label', value);
  };
  const update = () => document.querySelectorAll(roots).forEach(root => {
    root.querySelectorAll('.AirReviews-Modal__Title').forEach(element => {
      if (!element.id) element.id = 'AirReviews-Modal-title';
    });
    root.querySelectorAll('legend.AirReviews-sr-only').forEach(element => {
      if (element.textContent === 'Star rating') element.textContent = copy.rating;
    });
    root.querySelectorAll('input[type="radio"].AirReviews-sr-only').forEach(element => {
      const rating = Number(element.value);
      if (rating >= 1 && rating <= 5) {
        const suffix = ru ? (rating === 1 ? 'звезда' : rating < 5 ? 'звезды' : 'звёзд') : 'жұлдыз';
        label(element, `${rating} ${suffix}`);
      }
    });
    root.querySelectorAll('.AirReviews-Modal__Close').forEach(element => {
      label(element, copy.close);
      if (element.title !== copy.close) element.title = copy.close;
    });
    root.querySelectorAll('input[type="file"]').forEach(element => label(element, copy.files));
    root.querySelectorAll('textarea.AirReviews-Textarea').forEach(element => label(element, copy.review));
  });
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); paginate(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  update();
  paginate();
})();
